<template>
	<div class="map-toolbar d-flex flex-row" style="width:100%">
		<slot/>
	</div>
</template>

<script>

import toolbar_mix from '../mixins/toolbar/toolbar-container.js';

const methods = {

}

export default {

  name: 'base-toolbar',
  mixins: [toolbar_mix],
  data () {
    return {

    }
  },
  created () {

  	Object.defineProperties(this, /** @lends module:map/map# */{
        /**
         * OpenLayers map instance.
         * @type {ol.Map|undefined}
         */
        $map: {
          enumerable: true,
          get: () => this.$parent.$map,
        },
        /**
         * OpenLayers view instance.
         * @type {ol.View|undefined}
         */
        $view: {
          enumerable: true,
          get: () => this.$parent.$view,
        },
        $legendContainer: {
          enumerable: true,
          get: () => this.$parent.$viewContainer.$legendContainer,
        },
        $sources: {
          enumerable: true,
          get: () => this.$services.sources.getSources(),
        },
        $sourcesAdded: {
          enumerable: true,
        //   May need to write a function like getSources in sources.js
        //   that returns sourcesAdded and sourcesLoaded
          get: () => this.$services.sources.sourcesAdded,
        },
        $sourcesLoaded: {
          enumerable: true,
          get: () => this.$services.sources.sourcesLoaded,
        },
      })

  	// Check if map is loaded
  	this.beforeInit().then(() => {
  		// console.log("Mounting")
  		this.mountTools();
  	})
  },
  mounted () {
  	// console.log("this is the toolbar");
  	// console.log(this);
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/js/map/MapComponents/Base/BaseToolbar.vue